import stringScript from "./stringScript";
import Vue from 'vue';
export default class systemScript extends stringScript{
    constructor(system){
        super(system);
    }
    //关闭当前窗口
    CloseWindow(){
        this.system.manager.$.closeSingleView();
    }
    //关闭指定窗口
    CloseWindowEx(closeViewName){
        this.system.manager.$.closeWindow(closeViewName)
    }
    //关闭所有窗口
    CloseAllWindow(){
        this.system.manager.$.closeAllView()
    }
    //延期执行
    Delayed(...val){
        try{
            var valeLise = val.splice(2);
            this.setDelayed = setTimeout(function(){
                try{
                    var func = this[val[0]].bind(this);
                    func(valeLise[0],valeLise[1],valeLise[2],valeLise[3],valeLise[4],valeLise[5]); 
                    clearTimeout(this.setDelayed);
                }catch(e){
                    console.log("catch error: " + e.stack);
                    clearInterval(this.setCycle);
                }
            }.bind(this),val[1]);
        }catch(e){
            console.log("catch error: " + e.stack);
            clearTimeout(this.setDelayed)
        }
    }
    //周期执行
    Cycle(...val){
        try{
            clearInterval(this.setCycle)
            var valeLise = val.splice(3);
            var times = 0;
            this.setCycle = setInterval(function(){
                try{
                    var func = this[val[0]].bind(this);
                    func(valeLise[0],valeLise[1],valeLise[2],valeLise[3],valeLise[4],valeLise[5]); 
                    times = times + val[1];
                    if( times== val[2]){
                        clearInterval(this.setCycle);
                    }
                }catch(e){
                    console.log("catch error: " + e.stack);
                    clearInterval(this.setCycle);
                }
            }.bind(this),val[1]);
        }catch(e){
            console.log("catch error: " + e.stack);
            clearInterval(this.setCycle);
        }
    }
    //打开窗口
    async Display(openViewName,param){
        //打开串口设置历史回放停止
        this.system.historyPlaybackControl.$.suspend();
        // 如果打开过关闭窗口，在执行打开窗口操作， 否则直接show层级不生效
        if(this.system.manager[openViewName]){
           this.CloseWindowEx(openViewName)
        }
        if(param ==0 || param ==1 || param == 2 || param == 3){
            var result = await this.system.manager.$.openView(openViewName,param,"DisplayCom");
        }else{
            var result = await this.system.manager.$.openView(openViewName,param);
        }
        if(param == "Template"){
            return result;
        }else{
            if(result != true){
                return true;
            }else{
                return false;
            }
        }
        
    }
    /*
    功能
       数据库变量重定向
    语法
        VarRedir(var, NewTagPar)
    说明
        用于将数据库变量重定向中间变量，对于数据库
        变量改变，中变量值跟随数据库变量改变
        重定向后无法取消
    参数
        var: 字符串类型	重定向变量为中间变量（以创建变量）。
        NewTagPar:字符串类型，数据库中的点。
    示例
        VarRedir("dbvar", "a1.pv");//a1.pv将指向数中间变量dbvar
    */
    VarRedir(vardb,NewTagPar){
        if(NewTagPar.indexOf(".PV")>-1){
            NewTagPar = NewTagPar.replace(".PV","")
        }
        var arr = NewTagPar.split(".")
        var tags = __dbTags;
        for(var i =0;i<arr.length;i++){
            tags = tags["$"+[arr[i]]];
        }
        tags["value"] = tags["PV"];
        tags["DownTo"] = true;
        //事件代理
        __systemMidVar[vardb] = new Proxy(tags, {
            get(target, key,value) {
                if(key == "DownTo"){
                    return target["DownTo"];
                }
                if(key == "value"){
                    return target["PV"];
                }
            },
            set:function(target, key, value) {
                //下至数据库
                if(key == "value"){
                    var data = {
                        "head": "dataLayer",
                        "message" : {
                            "head" : "setData",
                            "message" : []
                        }
                    }
                    data.message.message[0] = {
                        name : "$"+NewTagPar.replace(".",".$"),
                        propsName : "PV",
                        value : value,
                        old : -9999,
                        quality :232
                    }
                    this.system.$.dbCom.sendMessage(data,function(err,resule){
                        //下置无权限
                        if(err){
                            err = this.system.$.getResource(err) || err;
                            alert(err+"下至接口报错");
                        }else{
                            //注册点
                            this.system.$.dbCom.declareTags([{firstValue:0,name:"__dbTags$"+NewTagPar.replace(".",".$")}]);
                            // Function(tagName + "=" + value)();
                        }
                    }.bind(this));
                    target["PV"] = value;
                    return value;
                }else if(key == "DownTo"){
                    return value;
                }
            }.bind(this)
        });
        //标记赋值
        __systemMidVar[vardb]["DownTo"] = true;
    }
    async GetStatisData(dbvar,Year, Month, Day, Hour,TimeSpan,Type){
        // Year, Month, Day, Hour指定的是开始时间，TimeSpan指定的是时间长度。
        // Var 欲存取的变量，该变量必须是DB变量，该参数不能包含在""中。
        // Year :整型，表示年,范围1999~2037 。0表示当年。
        // Month: 整型，表示月, 范围1~12。0表示当月。
        // Day: 整型，表示日, 范围1~31。0表示当天，负值表示前多少天，如-1 表示前1天，-2 表示前2天…。
        // Hour: 整型，表示时, 范围0~23。 负值表示前多少小时，如-1 表示前1小时，-2 表示前2小时…。
        // TimeSpan:整型，为时间范围，单位为小时。如果Hour为8，TimeSpan为1，表示7点~8点的统计数据（注意：对应于数据表中8点的数据）
        // 即后一个小时的统计数据；如果TimeSpan为2，则表示6点~8点的统计数据，即前2个小时的统计数据。
        // Type: 表示取何种统计数据。1-最小值 2-最大值 3-平均值 4-累计值 5-增量 6-加权平均
     

        // 1）var value = GetStatisData (FI101.PV,2000,12,21,11, 1,0);
        // 取数据库中的点FI101.PV在2000年12月21日10~11时的平均值。
        // 2）var value = GetStatisData (FI101.PV,0,0,-1,10,2,1);
        // 取数据库中的点FI101.PV在本年本月昨日8~10时的最大值。
        // 3）var value = GetStatisData (FI101.PV,0,0,-1,18,2,2);
        // 取数据库中的点FI101.PV在本年本月昨日16~18时的最小值。
        if(dbvar.indexOf(".PV")>-1){
            dbvar = dbvar.replace(".PV","")
        }
        if(Year == 0){
            Year = new Date().getFullYear();
            
        }
        if(Month == 0){
            Month = new Date().getMonth()+1;
        }
        if(Day < 0){
            var endDay = new Date().getDate() + Day;
        }else if(Day == 0){
            var endDay = new Date().getDate();
        }else{
            var endDay = Day;
        }
        if(Hour < 0){
            var endHour = new Date().getDate() + Hour;
        }else if(Hour == 0){
            var endHour = new Date().getDate();
        }else{
            var endHour = Hour;
        }
        //计算小时为当前时间为负数时 前某个小时为结束时间， 开始时间为结束时间加时间跨度
        //结束时间
        var endTime = new Date(Year+"."+Month+"."+endDay+" "+endHour+":00:00").getTime();//结束时间
        //开始时间
        var startTime = endTime -(3600000 * TimeSpan);
        var message = {
            "head": "dataLayer",
            "message" : {
                "head": "getStatisData",
                "varList": [dbvar],//["a.PV","b.PV"]
                "endTime": endTime,//起始时间 Date().GetTime
                "startTime": startTime,//时间跨度
                "hisType": Type,
                "hisStep":TimeSpan//时间跨度
            }
        }
        return new Promise((resolve,reject) => {
            this.system.$.dbCom.sendMessage(message,(err,result)=>{
                if(err){
                    reject(err);
                }else{
                    // console.log(result.varList[0].valueList[0].PV)
                    resolve(result.varList[0].valueList[0].PV);
                }
            });
        });
    }
    async GetVar(tagName) {
        //如果返回值是promise 那就是转译没有加 await
        if(tagName.indexOf('\\')>=0){
            tagName=tagName.replace(/\\/g,'.');
        }
        var nameArr = tagName.split(".");
        var attribute = nameArr[nameArr.length - 1];
        var name = tagName.replace("." + attribute,"");
        
        name = "$"+name.split(".").join(".$"); 
        var data = {
            "head": "dataLayer",
            "message" : {
                "head" : "getVar",
                "tagName" : name,
                "attribute" : attribute
            }
        }
        return await new Promise(async (resolve, reject)=>{
            this.system.$.dbCom.sendMessage(data,(tag,error)=>{
                resolve(tag[attribute]);
            });
        });
    }

    async GetVarStrq(tagName){
        return await GetVar(tagName)
    }
    /**  弹出变量选择对话框。
     * intbDbOnly:
        0表示可以选择，所有的变量
        1表示只选择数据库内的变量,禁用中间变量
     * nType：
        所选变量的类型 int 0:"DESC",1:"INDEX",2:"NAME",3:"PV",4:"TIME"
     * trOldVarName：
        默认选中 string型，预留参数,可用于记录上次选择的变量名 "test.tag.pv"
     * 示例 ： VarSelect(0,3,"test.tag.pv");
    */
    async VarSelect(intbDbOnly,nType,trOldVarName){
        var json = {0:"DESC",1:"INDEX",2:"NAME",3:"PV",4:"TIME"};
        this.system.tagsDialog.$.create(json[nType]);
        new Promise((resolve) => {//"FWebView.三角波.PV"
        // var trOldVarName = "FWebView.三角波.PV";
        // var intbDbOnly = false;
        if(trOldVarName=="" || trOldVarName == undefined){
            trOldVarName = "FWebView.三角波.PV";
        }
        this.system.tagsDialog.$.show(trOldVarName,intbDbOnly,true,true,function(tagName){
            resolve(tagName);
        });
        }).then(function (tagName) {
           // {name: "testCase_Tag1.PV", desc: "psAPISDK测试"}
            return tagName.name;
          });
    }
    //调取历史回放显隐
    PlaybackShow(value){
        this.system.historyPlaybackControl.$.show(value);
    }
    //调取录屏软件显隐
    ScreencapShow(value){
        this.system.screencap.$.show(value);
    }
    //判断是否是app
    isApp(){
        window.isApp();
    }
    //打开点选择窗口 返回选中数据 对app有效
    getDataMenu(data){
        var tagName;
        this.selectData(data).then(function(name){
            
            tagName = name;
        })
        return tagName;
    }
    selectData(oldName){
        return new Promise((resolve) => {
            this.system.dataDialog.$.show(oldName,isMidVar=false,isDataSource=true,isLong=true,function(tagName){
                resolve(tagName);
            });
        });
    }
    OpenNewUrl(url){
        // 编译问题，  斜杠编译成点了，以及不添加http协议无法跳转
        //网址中如有/需要以 %/ 因编译问题如此写法
        if(url.indexOf("http:..")>-1){
            url = url.replace("http:..","http://");
            url = url.replace(".?","/?")
            // url = "http://"+url.substring(url.indexOf("w"),url.length);
        }
        if(url.indexOf("http://")==-1|| url.indexOf("http:..")>-1){
            url = url.replace(".?","/?")
            url = "http://"+url;
        }
        url=url.replace(/%./g,'/');
        var a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("target", "_blank");
        a.setAttribute("id", "camnpr");
        document.body.appendChild(a);
        a.click();
    }

    GotoUrl(url){
        // 编译问题，  斜杠编译成点了，以及不添加http协议无法跳转
        //网址中如有/需要以 %/ 因编译问题如此写法
        if(url.indexOf("http:..")>-1){
            url = url.replace("http:..","http://");
            url = url.replace(".?","/?")
        }
        if(url.indexOf("http://")==-1|| url.indexOf("http:..")>-1){
            url = url.replace(".?","/?")
            url = "http://"+url;
        }
        url=url.replace(/%./g,'/');
        location.href=url;
    }
    //隐藏窗口
    HideWindow(viewName){
        this.system.manager.$.hideView(viewName);
    }
    /**
     * 作用：用来获取时间
     * 参数：如果是字符串时间那就换算成秒和毫秒
     * 参数：如果是秒，维护老的工程获得日期时间的 年 月 日 时 分 秒
     */
    IntTime(time,format){
        var times;
        time = time*1000;
        var date = new Date(time);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if(month<10){
            month="0"+month;
        }
        var dates = date.getDate();
        if(dates<10){
            dates="0"+dates;
        }
        var hours = date.getHours();
        if(hours<10){
            hours="0"+hours;
        }
        var minutes = date.getMinutes();
        if(minutes<10){
            minutes="0"+minutes;
        }
        var seconds = date.getSeconds();
        if(seconds<10){
            seconds="0"+seconds;
        }
        switch (format){
            case -1://返回年月日
                //times = year+"/"+month+"/"+dates+" "+hours+":"+minutes+":"+seconds;
                times = 1970;
                break;
            case 0:
                times = year;
                break;
            case 1:
                times = month;
                break;
            case 2:
                times = dates;
                break;
            case 3:
                times = hours;
                break;
            case 4:
                times = minutes;
                break;
            case 5:
                times = seconds;
                break;
            default:
                break;
        }
        return times;
    }
    /**
     * 作用：将字符串形式表示的时间转成整型数。
     * 返回值:为整型数表示的时间，是自1970年1月1日零时逝去的秒数。
     * 参数：YYYY/MM/DD hh:mm:ss
     */
    longTime(time){
        return new Date(time).getTime()/1000; 
    }
    /**
     * 作用：用于使用毫秒数转字符串 年月日时分秒以及字符串的格式
     * 参数：毫秒
     * 参数：0-8 分别格式
     * 0：yyyy/mm/dd hh:mm:ss(2014/01/03 05:02:15)
    1：yyyy-mm-dd hh:mm:ss(2014-01-03 05:02:15)
    2：yyyy/m/d hh:mm:ss(2014/1/3 5:02:15)
    3: yyyy-m-d hh:mm:ss(2014-1-3 5:02:15)
    4: yyyy年mm月dd日 hh:mm:ss(2014年01月03日 05:02:15）
    5: yyyy年m月d日 hh:mm:ss(2014年1月3日 5:02:15）
     */
    StrTime(time,form){
        var times;
        time =  Function("return " + time)();
        var date = new Date(time);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if(month<10){
            month="0"+month;
        }
        var dates = date.getDate();
        if(dates<10){
            dates="0"+dates;
        }
        var hours = date.getHours();
        if(hours<10){
            hours="0"+hours;
        }
        var minutes = date.getMinutes();
        if(minutes<10){
            minutes="0"+minutes;
        }
        var seconds = date.getSeconds();
        if(seconds<10){
            seconds="0"+seconds;
        }
        switch (form){
            case 0:
                var timeFormat = "yyyy/MM/dd hh:mm:ss";
                times = date.format(timeFormat);
                break;
            case 1:
                var timeFormat = "yyyy-MM-dd hh:mm:ss";
                times = date.format(timeFormat);
                break;
            case 2://(2014/1/3 5:02:15)
                times = times = year+"/"+month+"/"+dates+" "+hours+":"+minutes+":"+seconds;
                break;
            case 3://(2014-1-3 5:02:15)
                var timeFormat = "yyyy-m-d hh:mm:ss";
                times = times = year+"-"+month+"-"+dates+" "+hours+":"+minutes+":"+seconds;
                break;
            case 4:
                var timeFormat = "yyyy年MM月dd日 hh:mm:ss";
                times = date.format(timeFormat);
                break;
            case 5://(2014年1月3日 5:02:15）
                times = times = year+"年"+month+"月"+dates+"日 "+hours+":"+minutes+":"+seconds;
                break;
            default:
                break;
        }
        return times;
    }

    IsAlarm(modelRule){
        var temp = modelRule.split(".");
        this.system.$._regTempAlarmObj(temp);
        return alarmContent[temp[0]][temp[1]] ? true : false;
    }
    async MsgBox(text){
       
        var number = await new Promise(async (resolve, reject)=>{
            var MessageBox = new Vue({
                methods: {
                    instance (getResource) {
                        var timer=null;
                        clearTimeout(timer);
                        timer=setTimeout(()=>{
                            this.$Modal.confirm({
                                title: text,
                                okText: getResource('确定') || "确定",
                                cancelText: getResource('取消') || "取消",
                                content: '<p class="msboxStyle"> </p>',
                                onOk: () => {
                                    resolve(1);
                                },
                                onCancel: ()=>  {
                                    resolve(0);
                                }
                            });
                        },100)
                        //这里修改的是窗口的初始层级
                        //this.$Modal.props.zIndex.default = 8000;
                    }
                }
            })
            MessageBox.instance(this.system.$.getResource)
        })
        return number;
    }
    //产生自定义随机数
    Rand(count){
        count = Function("return " + count)();
        return Math.random()*count;
    }
    //定时器
    ReachTime(hours,minutes){
        var date = new Date();
        if(hours < -1 && hours > 24){
            return 1;
        }else if(minutes < 0 && minutes > 60){
            return 1;
        }else{
            var res = hours + ":" + minutes;
            var resMinute = minutes;
            if(hours == -1){
                if(date.getMinutes() == resMinute){
                    return 0;
                }else{
                    return 1;
                }
            }else{
                if(date.getHours() + ":" + date.getMinutes() == res){
                    return 1;
                }else{
                    return 0;
                }
            }
        }
    }
    //将一系列字符串组合起来形成一个新的字符串。
    StrFormat(formatcontrol,outlist){
        var temp=formatcontrol.substring(formatcontrol.lastIndexOf("%"),formatcontrol.length);
        var str=formatcontrol.substring(0,formatcontrol.lastIndexOf("%"));
        if(temp == "%d" || temp == "%i"){
            return str+outlist;
        }else if(temp == "%o"){
            var num = parseInt(outlist);
            var str1 = num.toString(8);
            return str+str1;
        }else if(temp == "%x"){
            var num = parseInt(outlist);
            var str1 = num.toString(16);
            return str+str1;
        }else if(temp == "%u"){
            var num=Math.abs(outlist);
            // var unsigned = outlist>>>0;
            return str+num;
        }else if(temp == "%c"){
            var ascii=String.fromCharCode(outlist);
            return str+ascii;
        }else if(temp == "%s"){
            return str+outlist;      
        }else if(temp == "%f"){
            var num = outlist.toFixed(6);
            return str+num;   
        }else if(temp == "%e"){
            var p = Math.floor(Math.log(outlist)/Math.LN10);
            var n = outlist * Math.pow(10, -p);
            return str+n + 'e' + p;
        }else if(temp == "%g"){
            var p = Math.floor(Math.log(outlist)/Math.LN10);
            var n = outlist * Math.pow(10, -p);
            var counta = str+n + 'e' + p;
            
            var num = eval(outlist.toFixed(6));
            var countb= str+num; 
            
            if(counta.length>countb.length){
                return countb;
            }
            return counta;
        }else if(temp.endsWith("s")){
            var list=temp.substring(1,temp.indexOf("s"));
            var m="";
            var toout="";
            if(list.indexOf(".") != -1){
                var n=list.substring(list.indexOf(".")+1,list.length);
                var out=outlist.toString().substring(0,n);
                if(list>0){
                    m=list.substring(0,list.indexOf("."));
                    for(i=0;i<(m-n);i++){
                        toout+=" ";
                    }
                    return str+toout+out;

                }else if(list<0){
                    m=list.substring(1,list.indexOf("."));
                    for(i=0;i<(m-n);i++){
                        toout+=" ";
                    }
                    return str+out+toout;
                }
            }

            m=Math.abs(list);
            var outlength=outlist.toString().length;
            if(outlength>m || outlength==m){
                return str+outlist;
            }else{
                for(i=0;i<(m-outlength);i++){
                    toout+=" ";
                }
                return str+outlist+toout;
            }
        }       
    }

    //打印当前窗口
    ToPrint(){
        this.system.$.toPrintView();
    }
    //打印制定窗口
    Print(winName){
        this.system.$.Print(winName);
    }
    //退出窗口重新登录
    LogOut(){
        this.CloseAllWindow();
        this.system.$.LogOut();
    }
    //重新登录 不关闭窗口
    ReLogin(){
        this.system.$.toLogin();
    }
    //返回到主页
    Homepage(){
        this.CloseAllWindow();
        for(let p in this.system.$.viewList){
            this.system.manager.$.openView(this.system.$.viewList[p]) 
        }
    }
    DbVarMsg(tagName,isToIo){
        this.value = 0;
        this.dialog = new Vue({
            methods: {
                show (data) {
                    //修改弹窗层级以2000开始，iview默认值以1000
                    this.$Modal.props.zIndex.default = 2000;
                    this.$Modal.confirm(data);
                }
            }
        });
        //函数在fvAnimation.js中声明
        this.dialog.show({
            data : { 
                ok : this.SetDbVarFn,
                value : 0,
            },
            okText: "确定",
            cancelText: "取消",
            title: tagName,
            loading: true,
            render: (h) => {
                return h('InputNumber', {
                    style : "width: 100%",
                    props: {
                        value: 0,
                        autofocus: true,
                        placeholder: "请输入要设置的数值",
                    },
                    on: {
                        input: (val) => {
                            this.value = val;
                        }
                    }
                })
            },
            onOk: () => {
                this.SetDbVarFn(tagName,this.value,isToIo);
                setTimeout(() => {
                    this.dialog.$Modal.remove();
                }, this.time);
            }
        });
    }
    SetDbVarFn(tagName,value,isToIo){
        if(tagName.indexOf(".PV")>0){
            if(tagName.indexOf("$")<0){
                tagName = tagName.substring(0,tagName.length-3);
                tagName = "$"+tagName.split(".").join(".$")+".PV"; 
            }
            if(tagName.indexOf("__dbTags")>-1){
            }else{
                tagName = "__dbTags."+tagName;
            }
            if(this.system.$.dbCom.isDbVar(tagName) == false){
                console.warn("页面未引用的数据库点下置,无法确定数据库中是否存在，不保证下置成功");
            }
            var data = {
                "head": "dataLayer",
                "message" : {
                    "head" : "setData",
                    "message" : [
                        
                    ]
                }
            }
            var nameArr = tagName.split(".");
            var name,start;
            if(nameArr[0] == "__dbTags"){
                start = 2;
                name = nameArr[1];
            }else{
                start = 1;
                name = nameArr[0];
            }
            var id = 13;
            var oldValue = window.__dbTags[name];
            for(var i = start; i < nameArr.length - 1;i++){
                if(oldValue){
                    oldValue = oldValue[nameArr[i]];
                }
                name += "." + nameArr[i];
            }
            var propsName =  nameArr[nameArr.length - 1];
            data.message.message[0] = {
                name : name,
                propsName : propsName,
                value : value,
                old : oldValue ? oldValue.PV : -9999,
                quality : isToIo? 232 : 192
            }
            this.system.$.dbCom.sendMessage(data,function(err,resule){
                //下置无权限
                if(err){
                    err = this.system.$.getResource(err) || err;
                    alert(err+"下至接口报错");
                }else{
                    //注册点
                    this.system.$.dbCom.declareTags([{firstValue:0,name:tagName.substring(0,tagName.length-3)}]);
                    // Function(tagName + "=" + value)();
                }
            }.bind(this));
        }else{
            //判断标记是否要通过中间变量下至数据库
            if(__systemMidVar[tagName].DownTo){
                __systemMidVar[tagName].value = value;
            }else{
                console.warn("通过中间变量下至数据，需要重定向过的");   
            }
        }
    }
    SetDbVar(tagName,value,isToIo){
        if(value == "MsgBox"){
            this.DbVarMsg(tagName,isToIo)
        }else{
            this.SetDbVarFn(tagName,value,isToIo);
        } 
    }

    ChangeLanguage(lName){
        this.system.$.languageName = lName;
        this.system.$.onResize();
    }

    GetTranslateText(id){
        var str = this.system.$.getResource(id);
        return str ? str : "";
    }
}


// WEBPACK FOOTER //
// ./src/js/script/js/systemScript.js